import { initializeApp } from 'firebase/app';
import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  signOut as firebaseSignOut,
  onAuthStateChanged,
  User,
} from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyAIsi0c1kt0qTnw8t5kXlI8JMh4exiYdlM",
  authDomain: "blahblah-87de8.firebaseapp.com",
  projectId: "blahblah-87de8",
  storageBucket: "blahblah-87de8.firebasestorage.app",
  messagingSenderId: "335512763032",
  appId: "1:335512763032:web:blahblahweb"  // Will need to add web app to Firebase
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

const googleProvider = new GoogleAuthProvider();

export async function signInWithGoogle(): Promise<string> {
  const result = await signInWithPopup(auth, googleProvider);
  const idToken = await result.user.getIdToken();
  return idToken;
}

export async function signOut(): Promise<void> {
  await firebaseSignOut(auth);
}

export function onAuthChange(callback: (user: User | null) => void): () => void {
  return onAuthStateChanged(auth, callback);
}

export async function getIdToken(): Promise<string | null> {
  const user = auth.currentUser;
  if (!user) return null;
  return user.getIdToken();
}
